export const DEFAULT_NAME = '产品概念助手';

export const APP_BASE_PATH =
  process.env.PATH_ENV === 'web' ? '/sys_hotcreativeAssistant_customize' : '';
export const LOGIN_PATH = `${APP_BASE_PATH}/wpslogin`;
export const WORKBENCH_PATH = `${APP_BASE_PATH}/workbench`;

/**
 * Modal size 通用弹窗宽度
 */
export const ModalSize = {
  width: '40%',

}

export const FormLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 19 },
}

export const FormTailLayout = {
  labelCol: { span: 4 },
  wrapperCol: { offset: 4, span: 19 },
  className: 'formBtn-flex-end',
};

/**
 * @description 输入框长度限制 名称类
 */
export const InputNameLength = {
  showCount: true,
  maxLength: 20,
  descriptions: 200
}

/**
 * @description 输入框长度限制 描述类
 */
export const InputDescLength = {
  showCount: true,
  maxLength: 200
}
